import {
    createFeatureSelector,
    createSelector
} from '@ngrx/store';
import { AuthState } from '../reducers/auth.reducers';
import { ErrorCodesEnum } from '@shared/enums/errorCodes.enum';

const authFeatureSelector = createFeatureSelector<AuthState>('auth');

export const selectIsLoggedIn = createSelector(
    authFeatureSelector,
    ({ loggedIn }) => !!loggedIn
);

export const selectApplicant = createSelector(
    authFeatureSelector,
    ({ applicant }) => applicant
);

export const selectApplicantDeletionScenarios = createSelector(
    authFeatureSelector,
    ({ applicantDeletionScenarios }) => applicantDeletionScenarios
);

export const selectApplicantHasForbiddenEmailDomain = createSelector(
    authFeatureSelector,
    ({ error }) => (error && error.status === 500 && error.message === ErrorCodesEnum.FORBIDDEN_EMAIL_DOMAIN)
);

export const selectIsProfileDeleted = createSelector(
    authFeatureSelector,
    ({ profileDeleted }) => !!profileDeleted
);
